/* eslint-disable @typescript-eslint/no-explicit-any */
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getError, closeError, closeSuccessInfo, getSucccessInfo } from '@/redux/reducers/monitorReducer';

import ErrorBoundary from './ErrorBoundary';
import React from 'react';

const mapStateToProps = createStructuredSelector({
  error: getError,
  successInfo: getSucccessInfo,
});

const mapDispatchToProps = {
  closeError,
  closeSuccessInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary as React.ComponentType<any>);
